import actionTypes from 'SRC/modules/redux/actionTypes'

export const setShowFilterModal = showFilterModal => ({
  type: actionTypes.SET_VEHICLE_PARTS_SHOW_FILTER_MODAL,
  payload: showFilterModal
})
